import { render, staticRenderFns } from "./StudentActivityStepEdit.vue?vue&type=template&id=0ab9e1f0&scoped=true"
import script from "./StudentActivityStepEdit.vue?vue&type=script&lang=js"
export * from "./StudentActivityStepEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentActivityStepEdit.vue?vue&type=style&index=0&id=0ab9e1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab9e1f0",
  null
  
)

export default component.exports